const defaultTypes = '.png, .jpg'

/**
 * Checks if the file is compatible with the declared Mime type
 *
 * @param {Object} file file object
 * @param {string} types list of allowed file types
 */
export function checkImageMimeType(file, types = defaultTypes) {
    const { type } = file
    if (!type) {
        return false
    }
    const parts = type.toLowerCase().split('/')
    const fileType = parts[parts.length - 1]
    const allowedTypes = types
        .toLowerCase()
        .replace(/image\/|\.| /gi, '')
        .split(',')

    return allowedTypes.indexOf(fileType) !== -1
}
